import convertServerSide from './convert-server-side'

const handler = (files, epsg) => convertServerSide(files, '/api/v2/geo/convert/shape', epsg)

handler.canHandle = file => /\.(zip|shp|dbf|shx|prj)$/i.test(file.name)

export default handler
